import React from 'react';
import { Mail, Phone, MapPin, Facebook, Twitter, Linkedin, Youtube } from 'lucide-react';
import { Link } from 'react-router-dom';

const Footer = () => {
  const solutionsLinks = [
    { name: 'LV Systems', path: '/solutions/lv' },
    { name: 'MV Systems', path: '/solutions/mv' },
    { name: 'Solar Energy', path: '/solutions/solar' },
    { name: 'Digital Energy', path: '/solutions/digital-energy' },
    { name: 'Industrial Automation', path: '/solutions/automation' },
    { name: 'Backup Power', path: '/solutions/backup-power' }
  ];

  const productLinks = [
    { name: 'UPS Systems', path: '/products/ups' },
    { name: 'Solar Panels', path: '/products/solar' },
    { name: 'Generators', path: '/products/generators' },
    { name: 'Access Control', path: '/products/access-control' },
    { name: 'Security Systems', path: '/products/security' },
    { name: 'Structured Cabling', path: '/products/cabling' }
  ];

  const quickLinks = [
    { name: 'Home', path: '/' },
    { name: 'About', path: '/about' },
    { name: 'Projects', path: '/projects' },
    { name: 'Contact', path: '/contact' }
  ];

  const socialLinks = [
    { icon: Facebook, href: '#', label: 'Facebook' },
    { icon: Twitter, href: '#', label: 'Twitter' },
    { icon: Linkedin, href: '#', label: 'LinkedIn' },
    { icon: Youtube, href: '#', label: 'YouTube' }
  ];

  return (
    <footer className="bg-gray-900 text-gray-300 py-8">
      <div className="container mx-auto px-4 md:px-6">
        <div className="grid grid-cols-1 md:grid-cols-5 gap-6 pb-6 border-b border-gray-800">
          {/* Company with BIGGER Logo */}
          <div className="md:col-span-1">
            <Link to="/" className="inline-block">
              <img 
                src="/images/logo/logo-footer.png" 
                alt="Linear Power Systems Ltd" 
                className="h-20 md:h-24 w-auto object-contain"
                onError={(e) => {
                  e.target.onerror = null;
                  e.target.style.display = 'none';
                  const parent = e.target.parentElement;
                  const fallback = document.createElement('div');
                  fallback.className = 'w-20 h-20 md:w-24 md:h-24 bg-[#006D77] rounded-2xl flex items-center justify-center shadow-lg';
                  fallback.innerHTML = '<span class="text-white font-extrabold text-2xl md:text-3xl">LPS</span>';
                  parent.appendChild(fallback);
                }}
              />
            </Link>
            <p className="text-xs text-gray-400 mt-2 max-w-xs leading-relaxed">
              Engineering electrical excellence for reliable power systems across Kenya and East Africa.
            </p>
            <div className="flex gap-2 mt-3">
              {socialLinks.map((social, idx) => {
                const Icon = social.icon;
                return (
                  <a
                    key={idx}
                    href={social.href}
                    aria-label={social.label}
                    className="w-8 h-8 rounded-full bg-gray-800 hover:bg-[#006D77] flex items-center justify-center transition-colors"
                  >
                    <Icon size={14} className="text-gray-400 hover:text-white transition-colors" />
                  </a>
                );
              })}
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="text-white font-semibold text-sm mb-3">Quick Links</h4>
            <ul className="space-y-1.5">
              {quickLinks.map((link) => (
                <li key={link.name}>
                  <Link to={link.path} className="text-xs text-gray-400 hover:text-white transition-colors">
                    {link.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Solutions */}
          <div>
            <h4 className="text-white font-semibold text-sm mb-3">Solutions</h4>
            <ul className="space-y-1.5">
              {solutionsLinks.map((item) => (
                <li key={item.name}>
                  <Link to={item.path} className="text-xs text-gray-400 hover:text-white transition-colors">
                    {item.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Products */}
          <div>
            <h4 className="text-white font-semibold text-sm mb-3">Products</h4>
            <ul className="space-y-1.5">
              {productLinks.map((link) => (
                <li key={link.name}>
                  <Link to={link.path} className="text-xs text-gray-400 hover:text-white transition-colors">
                    {link.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h4 className="text-white font-semibold text-sm mb-3">Contact</h4>
            <ul className="space-y-2 text-xs">
              <li>
                <a href="mailto:info@linearpowersystems.co.ke" className="text-gray-400 hover:text-white transition-colors flex items-center gap-2">
                  <Mail size={14} className="text-[#2F9ED9]" />
                  info@linearpowersystems.co.ke
                </a>
              </li>
              <li>
                <a href="tel:+254735338408" className="text-gray-400 hover:text-white transition-colors flex items-center gap-2">
                  <Phone size={14} className="text-[#2F9ED9]" />
                  0735 338 408
                </a>
              </li>
              <li className="flex items-start gap-2 text-gray-400">
                <MapPin size={14} className="text-[#2F9ED9] flex-shrink-0 mt-0.5" />
                Nairobi, Kenya
              </li>
            </ul>
          </div>
        </div>

        <div className="pt-4 flex flex-col sm:flex-row justify-between items-center text-xs text-gray-500">
          <p>&copy; {new Date().getFullYear()} Linear Power Systems Ltd.</p>
          <a href="https://linearpowersystems.co.ke" target="_blank" rel="noopener noreferrer" className="hover:text-white transition-colors mt-1 sm:mt-0">
            linearpowersystems.co.ke
          </a>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
